import {FlowPort} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';
import {IVisualDataStreamer} from '@mintdata-wsp/wsp/controllers/visualDesigner/visualData/VisualDataStreamer';
import {ResizeEvent} from '@mintdata-wsp/wsp/ui/components/resizable/Resizer';
import {SplitView} from '@mintdata-wsp/wsp/ui/components/resizable/SplitView';
import {OnPanelResize, PanelContentProps} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/layout/PanelView';
import {DebugBlockContext, DebugKind} from '@mintdata-wsp/wsp/ui/views/visualDesigner/panels/debugData/DebugDataPanel';
import {DebugDataView,} from '@mintdata-wsp/wsp/ui/views/visualDesigner/panels/debugData/general/DebugDataView';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./DebugBlockView.less');
const cx = classnames.bind(styles);

export interface DebugBlockPanelProps extends PanelContentProps
{
    context:DebugBlockContext;
}

@observer
export class DebugBlockView extends React.Component<DebugBlockPanelProps, any>
{
    private _listeners:OnPanelResize[] = [];

    @bind
    private _onSplitViewResized(e:ResizeEvent)
    {
        for( let listener of this._listeners )
        {
            if( listener && typeof listener === 'function' )
                listener(e);
        }
    }

    @bind
    private _addResizeListener(listener:OnPanelResize)
    {
        this.props.onPanelResize(listener);
        this._listeners.push(listener);
    }

    @bind
    private _renderBoth()
    {
        const {context} = this.props;
        const {inputStreamer, outputStreamer, inputPort, outputPort} = context;

        return  <SplitView isVisible={true} isVertical={true} firstPercentLength={0.50} onSplitViewResized={this._onSplitViewResized}>
                    <DebugDataView kind={DebugKind.Block} label={inputPort.name} streamer={inputStreamer} onPanelResize={this._addResizeListener}/>
                    <DebugDataView kind={DebugKind.Block} label={outputPort.name} streamer={outputStreamer} onPanelResize={this._addResizeListener}/>
                </SplitView>;
    }

    private _renderOne(port:FlowPort, streamer:IVisualDataStreamer)
    {
        return <DebugDataView kind={DebugKind.Block} label={port.name} streamer={streamer} onPanelResize={this._addResizeListener}/>;
    }

    render()
    {
        const {context} = this.props;
        const {block} = context;

        if( !block )
            return null;

        const {inputStreamer, outputStreamer, inputPort, outputPort} = context;

        return  <div className={cx('debugBlockView')}>
                    {
                        inputPort && outputPort?
                            this._renderBoth()
                            :
                            inputPort?
                                    this._renderOne(inputPort, inputStreamer)
                                    :
                                    outputPort?
                                        this._renderOne(outputPort, outputStreamer)
                                        :
                                        null
                    }
                </div>;
    }
}
